import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import Sanitize      from '@utils/sanitize';

import Draggable     from 'react-draggable';

import {Tooltip}         from 'pui-react-tooltip';
import {OverlayTrigger}  from 'pui-react-overlay-trigger';
// -------------------------------------------------------

const MIN_X = 5;
const MIN_Y = 60;

class EazyBar extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      loading      : false,
      mouseX       : 0,
      mouseY       : 0,
    };
    
    document.body.addEventListener('mousemove', function(e){
      this.setState({ mouseX: e.pageX, mouseY: e.pageY });
    }.bind(this));
  }
  // -------------------------------------------------------
  
  /*
   * メモ移動完了処理
   */
  handleStop(memoData, e, data) {
    let element = this.memoSetting.bind(this)(memoData.id);
    if( Object.keys(element).length == 0 ) return;
    
    let position = element.style.transform.replace('translate(','').replace('px, ',',').replace('px)','').split(',');
    Utils.request.bind(this)('/api/project/workflow/set_memo', { project_id: this.props.base.project.id, update: { memo_id: memoData.id, position: position } },
      function(res){
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  /*
   * メモ移動処理
   */
  memoSetting(key) {
    let elementData = {};
    
    let parent = document.getElementById('memo-contents');
    let children = Array.from(parent.children);
    
    children.map((element) => {
      if( element.id != ('memo_'+ key) ) return;
      if( element != null ){
        try {
          let position = element.style.transform.replace('translate(','').replace('px, ',',').replace('px)','').split(',');
          if( position[0] < MIN_X ) position[0] = MIN_X;
          if( position[1] < MIN_Y ) position[1] = MIN_Y;
          
          element.style.transform = 'translate('+ position[0] +'px, '+ position[1] +'px)';
          elementData = element;
        } catch(e) {}
      }
    });
    
    return elementData;
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    
    return (
      <div className="memo-contents">
        <ul id="memo-contents">
          { base.projects_memo.map((d, key) => {
            
            // ポジション設定
            let pos = { x: parseInt(d.position_x), y: parseInt(d.position_y) };
            if( isNaN(pos.x) == true ) pos.x = 0;
            if( isNaN(pos.y) == true ) pos.y = 0;
            if( pos.x < MIN_X ) pos.x = MIN_X;
            if( pos.y < MIN_X ) pos.y = MIN_Y;
            
            // 修正指示（エスケープ後に改行→<br />・URL→<a>の変換を行う）
            let message_text = null;
            try { message_text = Sanitize.nl2brWithLinks(d.message); } catch(e) {}
            
            return (
              <Draggable key={key +'_'+ d.id} handle=".handle" defaultPosition={pos} position={null} grid={[1, 1]} scale={1} onDrag={this.memoSetting.bind(this, d.id)} onStop={this.handleStop.bind(this, d)}>
                <li id={('memo_'+ d.id)}>
                  <div className="txt" dangerouslySetInnerHTML={{ __html: message_text }} />
                  { (d.name == null) ? <p className="user">{Utils.setDate(d.update_date, 'M/D HH:mm')} {d.email}</p> : <p className="user">{Utils.setDate(d.update_date, 'M/D HH:mm')} {d.name}</p> }
                  
                  <OverlayTrigger placement="top" delayShow={150} overlay={<Tooltip>ドラッグ&ドロップで移動</Tooltip>}>
                    <i className="material-icons drag handle" style={{ background: d.memo_color }}>drag_indicator</i>
                  </OverlayTrigger>
                  
                  <OverlayTrigger placement="top" delayShow={150} overlay={<Tooltip>メモの編集・削除</Tooltip>}>
                    <i className="material-icons edit" onClick={base.event.showMemoCreateModal.bind(this, d.id, d.message)}>edit</i>
                  </OverlayTrigger>
                </li>
              </Draggable>
            );
          })}
        </ul>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default EazyBar;